import React from "react";
import { Card, CardHeader, CardBody, Container } from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import useMediaBrowser from "./browser/useMediaBrowser";
import MediaBrowserView from "./browser/MediaBrowserView";

/**
 * Standalone "Media files" page: the media library manager. Thin wrapper around the
 * shared browser core (SCRUM-904) in "manage" mode — browse + create folder + upload
 * + per-image info/copy. Opens at the Cloudinary root and Home returns there.
 */
const IndexMediaContainer = () => {
  const vm = useMediaBrowser({ mode: "manage", initialPath: "", rootPath: "" });

  return (
    <>
      <SimpleHeader name="Folders" parentName="Media Files" />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader className="text-center">
            <h2 className="mb-0 text-primary">Media Files Folders</h2>
          </CardHeader>
          <CardBody>
            <MediaBrowserView {...vm} />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default IndexMediaContainer;
